(() => {
  if (window.novereCartDrawerInitialized) return;
  window.novereCartDrawerInitialized = true;

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-novere-remove-item]");
    if (!button) return;

    event.preventDefault();
    button.classList.add("is-loading");

    try {
      const response = await fetch(theme.routes.cartChange, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: button.dataset.novereRemoveItem, quantity: 0 }),
      });
      if (!response.ok) throw new Error("Cart item could not be removed");

      const cart = await response.json();
      document.dispatchEvent(new CustomEvent("cart:build"));
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    } catch (error) {
      button.classList.remove("is-loading");
      window.location.href = theme.routes.cartPage;
    }
  });
})();
